function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "290",
  height: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M287 0h-32c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
  fill: "#000",
  opacity: ".07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M287 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-32c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
  fill: "#142688"
}), /*#__PURE__*/React.createElement("path", {
  d: "M280.3 10.1h-.3c-.4 1-.7 1.5-1 3h1.9c-.3-1.5-.3-2.2-.6-3zm2.9 5.9h-1.7c-.1 0-.1 0-.2-.1l-.2-.9-.1-.2h-2.4c-.1 0-.2 0-.2.2l-.3.9c0 .1-.1.1-.1.1h-2.1l.2-.5 2.9-6.8c0-.5.3-.7.8-.7h1.5c.1 0 .2 0 .2.2l1.4 6.5c.1.4.2.7.2 1.1.1.1.1.1.1.2zm-13.4-.3l.4-1.8c.1 0 .2.1.2.1.7.3 1.4.5 2.1.4.2 0 .5-.1.7-.2.5-.2.5-.7.1-1.1-.2-.2-.5-.3-.8-.5-.4-.2-.8-.4-1.1-.7-1.2-1-.8-2.4-.1-3.1.6-.4.9-.8 1.7-.8 1.2 0 2.5 0 3.1.2h.1c-.1.6-.2 1.1-.4 1.7-.5-.2-1-.4-1.5-.4-.3 0-.6 0-.9.1-.2 0-.3.1-.4.2-.2.2-.2.5 0 .7l.5.4c.4.2.8.4 1.1.6.5.3 1 .8 1.1 1.4.2.9-.1 1.7-.9 2.3-.5.4-.7.6-1.4.6-1.4 0-2.5.1-3.4-.2-.1.2-.1.2-.2.1zm-3.5.3c.1-.7.1-.7.2-1 .5-2.2 1-4.5 1.4-6.7.1-.2.1-.3.3-.3h1.8c-.2 1.2-.4 2.1-.7 3.2-.3 1.5-.6 3-1 4.5 0 .2-.1.2-.3.2l-1.7.1zM257 8.2c0-.1.2-.2.3-.2h3.4c.5 0 .9.3 1 .8l.9 4.4c0 .1 0 .1.1.2 0-.1.1-.1.1-.1l2.1-5.1c-.1-.1 0-.2.1-.2h2.1c0 .1 0 .1-.1.2l-3.1 7.3c-.1.2-.1.3-.2.4-.1.1-.3 0-.5 0h-1.5c-.1 0-.2 0-.2-.2l-1.6-6.2c-.2-.2-.5-.5-.9-.6-.6-.3-1.7-.5-1.9-.5l-.1-.2z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245 0h-32c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
  fill: "#000",
  opacity: ".07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M245 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-32c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L224 15.6c0 .2.1.4.3.4h2.7l.4-3.4 1.8-2.2 4.7-2.1z",
  fill: "#003087"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H228c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4h2.1c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z",
  fill: "#3086C8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M233.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z",
  fill: "#012169"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(168)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
  fill: "#000",
  opacity: ".07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EB001B",
  cx: "15",
  cy: "12",
  r: "7"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#F79E1B",
  cx: "23",
  cy: "12",
  r: "7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22 12c0-2.4-1.2-4.5-3-5.7-1.8 1.3-3 3.4-3 5.7 0 2.3 1.2 4.5 3 5.7 1.8-1.2 3-3.3 3-5.7z",
  fill: "#FF5F00"
})), /*#__PURE__*/React.createElement("path", {
  d: "M161 0h-32c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
  fill: "#000",
  opacity: ".07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M161 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2h-32c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M137.5 5h3.5v11.5a2.5 2.5 0 01-2.5 2.5H135V7.5a2.5 2.5 0 012.5-2.5z",
  fill: "#006EBC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M144.5 5h3.5v11.5a2.5 2.5 0 01-2.5 2.5H142V7.5a2.5 2.5 0 012.5-2.5z",
  fill: "#F00036"
}), /*#__PURE__*/React.createElement("path", {
  d: "M151.5 5h3.5v11.5a2.5 2.5 0 01-2.5 2.5H149V7.5a2.5 2.5 0 012.5-2.5z",
  fill: "#2AB419"
}), /*#__PURE__*/React.createElement("path", {
  d: "M136.755 14.5c-1.06 0-2.122-.304-2.656-.987l.78-.676c.068 1.133 3.545 1.24 3.545-.19V9.5h1.802v3.147c0 .728-.574 1.322-1.573 1.632-.466.144-1.365.221-1.898.221zm8.116 0c-.674 0-1.388-.107-1.965-.366-.948-.425-1.312-1.206-1.3-2.199.012-1.014.436-1.782 1.468-2.165 1.319-.49 3.343-.261 3.926.27v.972c-.572-.521-1.958-.898-2.919-.46-.494.226-.737.917-.744 1.448-.006.56.245 1.252.744 1.497.953.467 2.39.04 2.919-.441v1.01c-.358.255-1.253.434-2.129.434zm8.679-2.587c.37-.235.582-.567.582-1.005 0-.438-.116-.687-.348-.939-.206-.207-.58-.469-1.238-.469H149v5h3.546c.696 0 1.097-.23 1.315-.415.283-.25.426-.53.426-.96 0-.431-.155-.908-.737-1.212zm-1.906-.281h-1.428v-1.444h1.495c.956 0 .944 1.444-.067 1.444zm.288 2.157h-1.716v-1.513h1.716c.986 0 1.083 1.513 0 1.513z",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M119 0H87c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
  fill: "#000",
  opacity: ".07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H87c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M121 16.95V21c0 1.1-.9 2-2 2h-11.772c7.896-1.815 12.043-4.601 13.772-6.05z",
  fill: "#EDA024"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#494949",
  d: "M93 11h20v2H93z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106 12c0 1.7-1.3 3-3 3s-3-1.4-3-3 1.4-3 3-3c1.7 0 3 1.3 3 3z",
  fill: "#EDA024"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M77 0H45c-1.7 0-3 1.3-3 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
  fill: "#000",
  opacity: ".07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H45c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
  fill: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M54 12v3.7c0 .3-.2.3-.5.2-1.9-.8-3-3.3-2.3-5.4.4-1.1 1.2-2 2.3-2.4.4-.2.5-.1.5.2V12zm2 0V8.3c0-.3 0-.3.3-.2 2.1.8 3.2 3.3 2.4 5.4-.4 1.1-1.2 2-2.3 2.4-.4.2-.4.1-.4-.2V12zm7.2-7H55c3.8 0 6.8 3.1 6.8 7s-3 7-6.8 7h8.2c3.8 0 6.8-3.1 6.8-7s-3-7-6.8-7z",
  fill: "#3086C8"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z",
  fill: "#000",
  opacity: ".07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32",
  fill: "#002663"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.971 10.268l.774 1.876H8.203l.768-1.876zm16.075.078h-2.977v.827h2.929v1.239h-2.923v.922h2.977v.739l2.077-2.245-2.077-2.34-.006.858zm-14.063-2.34h3.995l.887 1.935L16.687 8h10.37l1.078 1.19L29.25 8h4.763l-3.519 3.852 3.483 3.828h-4.834l-1.078-1.19-1.125 1.19H10.03l-.494-1.19h-1.13l-.495 1.19H4L7.286 8h3.43l.267.006zm8.663 1.078h-2.239l-1.5 3.536-1.625-3.536H12.06v4.81L10 9.084H8.007l-2.382 5.512H7.18l.494-1.19h2.596l.494 1.19h2.72v-3.935l1.751 3.941h1.19l1.74-3.929v3.93h1.458l.024-5.52-.001.001zm9.34 2.768l2.531-2.768h-1.822l-1.601 1.726-1.548-1.726h-5.894v5.518h5.81l1.614-1.738 1.548 1.738h1.875l-2.512-2.75h-.001z",
  fill: "#FFF"
})))));